import { z } from 'zod'

export function createPageSchema<T extends z.ZodType>(contentSchema: T) {
  return z.object({
    content: z.array(contentSchema),
    totalItems: z.number().min(0)
  })
}
